module.exports = __webpack_public_path__ + "media/claim/assets/images/right_panel/money_200_tr-a538e3501ff891bbf4d26c562ee414c4.png";